import { useEffect, useState } from "react";
import XGalleryWithText from "./XGalleryWithText";

const GallerywithOptions = ({ setState, state, field }) => {
  const [items, setItems] = useState<any>(
    state[field?.name] ? state[field?.name] : [{ id: "1", option: "", video: "" }],
  );

  useEffect(() => {
    setState({ ...state, [field?.name]: items });
  }, [items]);

  const updateGallery = (videoObj, currentItem, type) => {
    let updatedItem = {};
    if (type === "video") {
      updatedItem = items.map((cItem) =>
        cItem.id === currentItem ? { ...cItem, video: videoObj } : cItem,
      );
    } else {
      updatedItem = items.map((cItem) =>
        cItem.id === currentItem ? { ...cItem, image: videoObj } : cItem,
      );
    }
    setItems(updatedItem);
  };

  return <XGalleryWithText callBack={updateGallery} items={items} setItems={setItems} />;
};
export default GallerywithOptions;
